import filterObjectProperties from '../../../../helpers/objects/filterObjectProperties';
import mapObject from '../../../../helpers/objects/mapObject';
import objectToQueryString from '../../../../helpers/url/objectToQueryString';
import Indexable from '../../../../types/DataStructure/Indexable';
import BookingParameters from '../../../types/BookingParameters';

import bookingParameterKeys from './bookingParameterKeys';

type KeysAsType = (typeof bookingParameterKeys)[number];

export type RelevantBookingParameters = Pick<BookingParameters, KeysAsType>;

const relevantQueryStringParams = (
    params: BookingParameters
): RelevantBookingParameters => {
    return filterObjectProperties(params, (key, value) => {
        // @ts-ignore TS knows what allowed values are in `bookingParameterKeys`, but we want to check key anyway :(
        return bookingParameterKeys.indexOf(key) >= 0 && !!value;
    }) as RelevantBookingParameters;
};

const compileUrlForParameters = (url: string, params?: BookingParameters) => {
    const mergedParams: RelevantBookingParameters = relevantQueryStringParams({
        ...(params ?? {}),
    } as BookingParameters);

    // Filter out the undefined values
    const filteredParams = filterObjectProperties(
        mergedParams,
        (key, value) => {
            return typeof value !== 'undefined';
        }
    );

    /**
     * Remove keys that have been explicitly set to undefined
     */
    const paramsAsStrings = mapObject(filteredParams, (value) =>
        value?.toString()
    ) as Indexable<string | number>;

    return `${url}?${objectToQueryString(paramsAsStrings)}`;
};

export default compileUrlForParameters;
